export function postTrackingEvents(endpoint, events, { keepalive = false } = {}) {
  const token = localStorage.getItem("access_token");
  if (!token || events.length === 0) return;

  fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ events }),
    keepalive,
  }).catch(() => {});
}

export function getPathLabel(pathname, labels, fallback = null) {
  if (!pathname) return fallback;

  const match = labels.find(([prefix]) => pathname.startsWith(prefix));
  return match ? match[1] : fallback;
}
